<template>

    <v-section bg="dark" col="col-md-8">
        <h3 class="text-center">{{ title }}</h3>
        <p class="mb-30">See how automations based on customer behavior can increase engagement and drive more upgrades. Get started for free. No credit card required.</p>
        <v-signup class="mb-15" />
        <v-claims theme="light" />
    </v-section>

</template>

<script>

export default {

    props: {
        title: {
            type: String,
            default: 'Ready to convert more leads into paying customers?',
        },
    },

}

</script>